import React from 'react'
import { Modal, Typography, InputNumber } from 'antd'
import styled from '@emotion/styled'
import { format } from 'date-fns-tz'

import { ModalContentContainer } from '../modal.common'

const { Text } = Typography

export const ModalApprove: React.FC<ModalApproveProps> = ({
	isOpened,
	onApprove,
	onCancel,
	isLoading,
	refundInfo,
}) => (
	<Modal
		open={isOpened}
		title="환급 승인"
		okText="확인"
		cancelText="취소"
		closable={false}
		onOk={onApprove}
		onCancel={onCancel}
		confirmLoading={isLoading}
	>
		<ModalContentContainer>
			{refundInfo ? (
				<>
					<div style={{ marginBottom: '20px' }}>
						<Text>환급액</Text>
						<div style={{ marginTop: '5px' }}>
							<InputNumber
								value={refundInfo.refundAmount}
								addonAfter="원"
								controls={false}
								formatter={(value) => new Intl.NumberFormat().format(value ?? 0)}
								style={{ width: '100%' }}
							/>
						</div>
					</div>

					<div>
						<KeyValue>
							<Text type="secondary">주문번호</Text>
							<Text>{refundInfo.orderNo}</Text>
						</KeyValue>

						<KeyValue>
							<Text type="secondary">닉네임</Text>
							<Text>{refundInfo.nickname}</Text>
						</KeyValue>

						<KeyValue>
							<Text type="secondary">구매상품</Text>
							<Text>{refundInfo.product}</Text>
						</KeyValue>

						<KeyValue>
							<Text type="secondary">결제일시</Text>
							<Text>{refundInfo.paymentDatetime}</Text>
						</KeyValue>

						<KeyValue>
							<Text type="secondary">결제액</Text>
							<Text>{new Intl.NumberFormat().format(refundInfo.paymentAmount)}</Text>
						</KeyValue>

						<KeyValue>
							<Text type="secondary">부분 취소액</Text>
							<Text>{new Intl.NumberFormat().format(refundInfo.refundAmount)}</Text>
						</KeyValue>
					</div>
				</>
			) : (
				'none'
			)}
		</ModalContentContainer>
	</Modal>
)

export type ModalApproveProps = {
	isOpened: boolean
	onApprove: () => void
	onCancel: () => void
	isLoading: boolean
	refundInfo?: {
		refundAmount: number
		orderNo: string
		nickname: string
		product: string
		paymentDatetime: string
		paymentAmount: number
	}
}

const KeyValue = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-bottom: 5px;
`
